// extracted by mini-css-extract-plugin
export default {"sib-links":"HEM_9BvxyWxUvPQCoG5c"};